const invoice = [{
  desc: '发票信息维护',
  options: {
    url: '/invoiceTitle/addOrUpdateInvoiceTitle',
    method: 'post'
  }
}, {
  desc: '获取商户的发票信息',
  options: {
    url: '/invoiceTitle/queryInvoicesByPartnerId',
    method: 'post'
  }
}]
export default invoice



// WEBPACK FOOTER //
// ./src/api/invoice.js